import {
	IonButton,
	IonButtons,
	IonContent,
	IonFooter,
	IonHeader,
	IonIcon,
	IonPage,
	IonTitle,
	IonToolbar,
} from "@ionic/react";
import { useHistory } from "react-router";
import useAuth from "../../context/auth.context";
import "./LandingPage.css";
import { logOutOutline } from 'ionicons/icons';
import { Guard } from "../../components/guard";
import imgSrc from "../../assets/logo.svg";
import imgSrcDark from "../../assets/logo_dark.svg";

import { cog } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import { useSettingsContext } from '../../context/settings.context';

const environment = process.env.REACT_APP_ENV;
const version = process.env.REACT_APP_VERSION;

function LandingPage() {
	const history = useHistory();
	const { t } = useTranslation();
	const { logout } = useAuth();
	const { roles, theme } = useSettingsContext();


	function onCollectData() {
		history.push("/barcode");
	}

	function onSearchSparePart() {
		history.push("/search");
	}

	function onManage() {
		history.push("/management");
	}

	function onLogout() {
		logout().subscribe(() => history.push("/signin"));
	}

	function onOpenSettings() {
		history.push("/settings");
	}

	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonButtons slot="start">
						<IonButton shape="round" onClick={onOpenSettings}>
							<IonIcon icon={cog}></IonIcon>
						</IonButton>
					</IonButtons>
					<IonTitle>
						{t("landing.title", { version, environment })}
					</IonTitle>
					<IonButtons slot="end">
						<IonButton onClick={onLogout} size="large">
							<IonIcon icon={logOutOutline} slot="icon-only" />
						</IonButton>
					</IonButtons>
				</IonToolbar>
			</IonHeader>
			<IonContent>
				<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
					<img src={theme === "light" ? imgSrc : imgSrcDark} style={{ width: "50%", margin: "auto" }} alt="Logo" />
				</div>
			</IonContent>
			<IonFooter>
				<Guard
					requiredRoles={["COLLECT", "ADMIN"]}
					currentRoles={roles}
				>
					<IonButton expand="block" onClick={onCollectData}>
						{t("landing.collectData")}
					</IonButton>
				</Guard>
				<Guard
					requiredRoles={["ADMIN"]}
					currentRoles={roles}
				>
					<IonButton expand="block" onClick={onManage}>
						{t("landing.management")}
					</IonButton>
				</Guard>

				<Guard
					requiredRoles={["SEARCH", "ADMIN"]}
					currentRoles={roles}
				>
					<IonButton expand="block" onClick={onSearchSparePart}>
						{t("landing.search")}
					</IonButton>
				</Guard>
			</IonFooter>
		</IonPage>
	);
}

export default LandingPage;
